// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-marker-container {
  position: relative;
  background: #212121;
  color: #fafafa;
  text-align: left;
  border-radius: 0.6rem;
  z-index: 1000;
  min-width: 18rem;
}

.location-marker-container-sm {
  position: relative;
  min-width: 12.8rem !important;
  background: #212121;
  color: #fafafa;
  text-align: left;
  border-radius: 0.6rem;
  z-index: 10 !important;
}

.location-marker-container-md {
  position: relative;
  background: #212121;
  color: #fafafa;
  text-align: left;
  border-radius: 0.6rem;
}

.location-marker-container-lg {
  position: relative;
  background: #212121;
  color: #fafafa;
  text-align: left;
  border-radius: 0.6rem;
  min-width: 16rem;
}

.coord-inner {
  display: inline-block;
  margin-bottom: 0.8rem;
  margin-top: 0.6rem;
}

.coord-section {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.coord-section-lg {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.location-hd {
  font-weight: bold;
  font-size: smaller;
}

.inner-hd {
  font-size: x-small;
  color: #9e9e9e;
  display: inline-block;
}

.inner-subhd {
  font-size: x-small;
}

.close-icon {
  position: absolute;
  top: -0.1rem;
  right: 1rem;
  cursor: pointer;
  max-width: 0.8rem;
}

.expand-icon {
  position: absolute;
  top: -0.1rem;
  right: 2rem;
  cursor: pointer;
  max-width: 1.2rem;
}

.view-icon {
  position: absolute;
  top: -0.1rem;
  right: 1rem;
  cursor: pointer;
  max-width: 1.2rem;
}

.location-marker-txt {
  font-size: x-small;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 0.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.location-shd {
  font-size: smaller;
  display: inline-block;
  margin-top: 0.6rem;
  text-overflow: ellipsis;
  max-width: 200px;
}

.noMargin {
  margin-top: 0rem !important;
}

.location-marker {
  transition: width 0.3s, height 0.3s; /* Smooth transition */
  padding: 0.8rem 0.8rem;
  margin-top: -2rem;
  margin-right: -2rem;
}

.custom-marker.bottom-marker {
  position: absolute;
  bottom: 10px;
  left: calc(50% + 20px);
  transform: translateX(-50%);
  z-index: 1000;
}

.remove-bin {
  border: 1px solid #b3261d;
  border-radius: 2px;
  color: #b3261d;
  background-color: transparent;
  padding: 4px 8px;
  margin: 0 auto;
  display: block;
  font-size: 12px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.delete-icon {
  width: 1.5rem !important;
  height: 1.5rem !important;
  margin-right: 0.5rem;
  margin-bottom: -4px;
}

.center-location {
  bottom: 12rem !important;
  top: auto !important;
  right: 14px !important;
}

.center-location-button {
  background-color: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.center-location-icon {
  width: 34px !important;
  height: 34px !important;
}

.center-location-button:hover {
  outline: none;
}

.gis-dropdown {
  width: auto;
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 1000;
  height: 3rem;
  border: 1px solid #e0e0e0;
}

.gis-dropdown select:focus-visible {
  outline: none;
}

.gis-dropdown select {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

/* Custom Chatbot Tooltip Styles */
.chatbot-tooltip-container {
  position: fixed;
  bottom: 6.8rem;
  right: 3rem;
  z-index: 1001;
  animation: slideUpAndFadeIn 0.5s ease-out;
}

.chatbot-tooltip-box {
  background: #FFF;
  border-radius: 12px;
  padding: 1rem 1rem 1.5rem;
  min-width: 15rem;
  max-width: 16rem;
  position: relative;
  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12); */
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
}

.chatbot-tooltip-text {
  color: #000000;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
  padding-right: 20px;
}

.chatbot-tooltip-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  color: #000000;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.chatbot-tooltip-close:hover {
  transform: scale(1.2);
}

/* Pointer/Tail - Chat Bubble Shape */
.chatbot-tooltip-pointer {
  position: absolute;
  bottom: -3px;
  z-index: -1;
  right: 1%;
  rotate: 230deg;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 14px solid;
  color: #fff;
  border-top-color: #FFF;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.15));
  animation: pointerPulse 0.6s ease-out;
}

/* Animations */
@keyframes slideUpAndFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Robot Chatbot Button Styles */
.chatbot-robot-button {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: visible;
  padding: 0;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chatbot-gif {
  width: 5rem;
  height: 5rem;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.chatbot-robot-button:hover .chatbot-gif {
  transform: scale(1.1);
}

.chatbot-robot-button:active .chatbot-gif {
  transform: scale(0.95);
}

/* Responsive adjustments */
/* @media (max-width: 480px) {
  .chatbot-tooltip-container {
    right: 5px;
  }

  .chatbot-tooltip-box {
    min-width: 200px;
    max-width: 280px;
    padding: 12px 16px;
  }

  .chatbot-tooltip-text {
    font-size: 13px;
  }

  .chatbot-robot-button {
    padding: 10px 16px;
    font-size: 13px;
  }
} */`, "",{"version":3,"sources":["webpack://./src/gis/src/components/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,kCAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,uBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAeA;EACE,mCACE,EACa,sBAAA;EACf,sBAAA;EACA,iBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,wBAAA;EAEA,oBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,qDAAA;EACA,iCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAfF;;AAkBA;EACE,sBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,aAAA;AAfF;;AAsBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,aAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,yBAAA;AAnBF;;AAuBA,kCAAA;AAEA;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,yCAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,kDAAA;AArBF;;AAwBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AArBF;;AAwBA;EACE,qBAAA;AArBF;;AAwBA,qCAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,kDAAA;EACA,qCAAA;AArBF;;AAwBA,eAAA;AACA;EACE;IACE,UAAA;IACA,2BAAA;EArBF;EAuBA;IACE,UAAA;IACA,wBAAA;EArBF;AACF;AAwBA,gCAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AAtBF;;AAyBA;EACE,qBAAA;AAtBF;;AAyBA;EACE,sBAAA;AAtBF;;AAwBA,2BAAA;AACA;;;;;;;;;;;;;;;;;;;GAAA","sourcesContent":[".location-marker-container {\n  position: relative;\n  background: #212121;\n  color: #fafafa;\n  text-align: left;\n  border-radius: 0.6rem;\n  z-index: 1000;\n  min-width: 18rem;\n}\n\n.location-marker-container-sm {\n  position: relative;\n  min-width: 12.8rem !important;\n  background: #212121;\n  color: #fafafa;\n  text-align: left;\n  border-radius: 0.6rem;\n  z-index: 10 !important;\n}\n\n.location-marker-container-md {\n  position: relative;\n  background: #212121;\n  color: #fafafa;\n  text-align: left;\n  border-radius: 0.6rem;\n}\n\n.location-marker-container-lg {\n  position: relative;\n  background: #212121;\n  color: #fafafa;\n  text-align: left;\n  border-radius: 0.6rem;\n  min-width: 16rem;\n}\n\n.coord-inner {\n  display: inline-block;\n  margin-bottom: 0.8rem;\n  margin-top: 0.6rem;\n}\n\n.coord-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.coord-section-lg {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.location-hd {\n  font-weight: bold;\n  font-size: smaller;\n}\n\n.inner-hd {\n  font-size: x-small;\n  color: #9e9e9e;\n  display: inline-block;\n}\n\n.inner-subhd {\n  font-size: x-small;\n}\n\n.close-icon {\n  position: absolute;\n  top: -0.1rem;\n  right: 1rem;\n  cursor: pointer;\n  max-width: 0.8rem;\n}\n\n.expand-icon {\n  position: absolute;\n  top: -0.1rem;\n  right: 2rem;\n  cursor: pointer;\n  max-width: 1.2rem;\n}\n\n.view-icon {\n  position: absolute;\n  top: -0.1rem;\n  right: 1rem;\n  cursor: pointer;\n  max-width: 1.2rem;\n}\n\n.location-marker-txt {\n  font-size: x-small;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  margin-top: 0.6rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n}\n\n.location-shd {\n  font-size: smaller;\n  display: inline-block;\n  margin-top: 0.6rem;\n  // white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 200px;\n}\n\n.noMargin {\n  margin-top: 0rem !important;\n}\n\n// .location-marker:after,\n// .location-marker:before {\n//     border-left: 8px solid transparent;\n//     border-right: 8px solid transparent;\n//     border-top: 6px solid #212121;\n//     bottom: -0.4rem;\n//     content: \"\";\n//     left: 65%;\n//     margin-left: -20px;\n//     position: absolute;\n// }\n\n.location-marker {\n  transition:\n    width 0.3s,\n    height 0.3s; /* Smooth transition */\n  padding: 0.8rem 0.8rem;\n  margin-top: -2rem;\n  margin-right: -2rem;\n}\n\n.custom-marker.bottom-marker {\n  position: absolute;\n  bottom: 10px;\n  left: calc(50% + 20px);\n  transform: translateX(-50%);\n  z-index: 1000;\n}\n\n.remove-bin {\n  border: 1px solid #b3261d;\n  border-radius: 2px;\n  color: #b3261d;\n  background-color: transparent;\n  padding: 4px 8px;\n  margin: 0 auto;\n  display: block;\n  font-size: 12px;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n\n.delete-icon {\n  width: 1.5rem !important;\n  height: 1.5rem !important;\n  margin-right: 0.5rem;\n  margin-bottom: -4px;\n}\n\n.center-location {\n  bottom: 12rem !important; // Position below zoom (adjust based on zoom height)\n  // left: 20px !important;\n  top: auto !important;\n  right: 14px !important;\n}\n\n.center-location-button {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  border: 1px solid #ccc !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.center-location-icon {\n  width: 34px !important;\n  height: 34px !important;\n}\n\n.center-location-button:hover {\n  outline: none;\n}\n\n.center-location-button:hover {\n  // background-color: rgba(255, 255, 255, 1) !important;\n}\n\n.gis-dropdown {\n  width: auto;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  z-index: 1000;\n  height: 3rem;\n  border: 1px solid #e0e0e0;\n}\n\n.gis-dropdown select:focus-visible {\n  outline: none;\n}\n\n.gis-dropdown select {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n\n/* Custom Chatbot Tooltip Styles */\n\n.chatbot-tooltip-container {\n  position: fixed;\n  bottom: 6.8rem;\n  right: 3rem;\n  z-index: 1001;\n  animation: slideUpAndFadeIn 0.5s ease-out;\n}\n\n.chatbot-tooltip-box {\n  background: #FFF;\n  border-radius: 12px;\n  padding: 1rem 1rem 1.5rem;\n  min-width: 15rem;\n  max-width: 16rem;\n  position: relative;\n  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12); */\n  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));\n}\n\n.chatbot-tooltip-text {\n  color: #000000;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0;\n  padding-right: 20px;\n}\n\n.chatbot-tooltip-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: transparent;\n  border: none;\n  color: #000000;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n}\n\n.chatbot-tooltip-close:hover {\n  transform: scale(1.2);\n}\n\n/* Pointer/Tail - Chat Bubble Shape */\n.chatbot-tooltip-pointer {\n  position: absolute;\n  bottom: -3px;\n  z-index: -1;\n  right: 1%; \n  rotate: 230deg;\n  width: 0;\n  height: 0;\n  border-left: 12px solid transparent;\n  border-right: 12px solid transparent;\n  border-top: 14px solid ;\n  color: #fff;\n  border-top-color: #FFF;\n  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.15));\n  animation: pointerPulse 0.6s ease-out;\n}\n\n/* Animations */\n@keyframes slideUpAndFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n} \n\n/* Robot Chatbot Button Styles */\n.chatbot-robot-button {\n  background: transparent;\n  border: none;\n  cursor: pointer; \n  transition: all 0.3s ease; \n  overflow: visible;\n  padding: 0;\n  width: auto;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chatbot-gif {\n  width: 5rem;\n  height: 5rem;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.chatbot-robot-button:hover .chatbot-gif {\n  transform: scale(1.1);\n}\n\n.chatbot-robot-button:active .chatbot-gif {\n  transform: scale(0.95);\n} \n/* Responsive adjustments */\n/* @media (max-width: 480px) {\n  .chatbot-tooltip-container {\n    right: 5px;\n  }\n\n  .chatbot-tooltip-box {\n    min-width: 200px;\n    max-width: 280px;\n    padding: 12px 16px;\n  }\n\n  .chatbot-tooltip-text {\n    font-size: 13px;\n  }\n\n  .chatbot-robot-button {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
